import React, {useEffect, useState} from "react";
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import attendanceServices from "app/services/attendance-services";
import {hhmm} from "./attendanceFormat";

// Cargar un tramo olvidado o corregir uno. Queda marcado como corregido por quien lo guarda.
const MarkDialog = ({open, onClose, onSaved, userId, date, mark}) => {
    const [form, setForm] = useState({date: "", check_in: "", check_out: "", note: ""});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open) return;
        setForm({
            date: mark ? mark.check_in_at.slice(0, 10) : date,
            check_in: mark ? hhmm(mark.check_in_at) : "",
            check_out: mark ? hhmm(mark.check_out_at) : "",
            note: mark?.note || ""
        });
    }, [open, mark, date]);

    const set = (key) => (e) => setForm((f) => ({...f, [key]: e.target.value}));

    const guardar = async () => {
        try {
            setSaving(true);
            const payload = {...form, user_id: userId};
            if (mark) await attendanceServices.updateMark(mark.id, payload);
            else await attendanceServices.createMark(payload);
            onSaved();
        } catch (_error) {
            // El interceptor global muestra el motivo.
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{mark ? "Corregir tramo" : "Agregar tramo"}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{pt: 1}}>
                    <Alert severity="info" variant="outlined">
                        Queda marcado como corregido a mano, con tu nombre y la hora.
                    </Alert>
                    <TextField type="date" label="Día" value={form.date} onChange={set("date")}
                               InputLabelProps={{shrink: true}}/>
                    <Stack direction="row" spacing={2}>
                        <TextField type="time" label="Entrada" value={form.check_in} onChange={set("check_in")}
                                   InputLabelProps={{shrink: true}} fullWidth/>
                        <TextField type="time" label="Salida" value={form.check_out} onChange={set("check_out")}
                                   InputLabelProps={{shrink: true}} helperText="Vacía si sigue abierto" fullWidth/>
                    </Stack>
                    <TextField label="Nota" value={form.note} onChange={set("note")} multiline minRows={2}/>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <LoadingButton variant="contained" loading={saving} disabled={!form.date || !form.check_in}
                               onClick={guardar}>
                    Guardar
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default MarkDialog;
